import { Spin } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Checking = () => {
  const navigate = useNavigate();
  const isCheck = localStorage.getItem("checkRole");
  useEffect(() => {
    if (isCheck != null) {
      if (isCheck) {
        navigate("/model", { replace: true });
      } else {
          localStorage.clear();
        navigate("/adminError", { replace: true });
      }
    }
  });

  return (
    <div className="centerPage">
      <Spin>
        <p>Please wait checking Role</p>
      </Spin>
    </div>
  );
};
